var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.042 15.958 1 31 16.042c-2.073 1.877-7.983 5.63-15.042 5.63S3.045 17.92 1 16.042zm11.597 11.26 3.36 3.53 7.228-7.059c-1.345.616-4.437 2.017-6.05 2.69-1.614.672-3.698.84-4.538.84zM6.378 15.118C8.9 14.22 15 12.648 19.235 13.52c4.236.875 6.863 2.158 7.647 2.69l-7.226 3.025c-2.017-1.204-7.496-3.714-13.278-4.117z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAst);
export default __webpack_public_path__ + "static/media/AST.4c35b2e0da7248a2f030e79a444ca9c7.svg";
export { ForwardRef as ReactComponent };